import { BaseApi, enhanceOpt } from '../couplingAjax'
import { Services } from '@/store/StoreTypes'

const ConfigServer = (request: typeof BaseApi, SERVIVE: Services) => {
  return {
    getDictByName: (dicName: string, opt?: enhanceOpt) => {
      return request({
        ...opt,
        url: `/dictionary/getDictByName?dictName=${dicName}`,
        method: 'get',
      })
    },

    checkWhiteList: (data: any, opt?: enhanceOpt) => {
      return request({
        ...opt,
        url: `/dictionary/checkWhiteList`,
        method: 'post',
        data,
      })
    },
  }
}

export default ConfigServer
